import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { IPgProps, ISearchPage } from "@/types/ScmTypes";
import React, { useState, useEffect } from "react";
import { PaginationProps } from "antd/es/pagination";
import { IRoleSearch, IRoleDetail, IRoleFields } from "./rolesType"
import { roleService } from "./rolesService";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "@/utils/constants";
import { message } from "antd";
import { globalPrompt } from "@/components/message";
import useGlobalModel from "@/model/globalModel";
import { transPgToPagination } from "@/utils/utils";


export const useRoleModel = createModel(function () {
    const { setRolesAllList } = useGlobalModel();

    const initSearchParam: IRoleSearch = {};
    const initDataSource: IRoleDetail[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

    //查询条件
    const [searchParam, setSearchParam] = useState<IRoleSearch>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IRoleDetail[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    //列表数据源分页参数
    const [selectedRow, setSelectedRow] = useState<IRoleFields>({});
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    const [drawerVisible, setDrawerVisible] = useState(false);
    useEffect(() => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.id === selectedRowKeys[0] : false);
        const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
        setSelectedRow(selectedData as IRoleFields)
    }, [selectedRowKeys])

    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }
    const updateSearchParam = (updateParam: IRoleSearch) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
        loadData(initPgCfg, {});
        setSelectedRowKeys([])
    }
    const loadData = async (page?: ISearchPage, searchValue: IRoleSearch = searchParam) => {
        const searchParams = {
            ...searchValue,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current)?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await roleService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
    }
    const loadAllRolesData = async () => {
        const searchParams = {
            pageSize: 200,
            pageNum: 1,
        }
        let { retData } = await roleService.page(searchParams);
        const { records, ...pg } = retData;
        setRolesAllList(records)
    }
    const onChange = async (id: string, checked: boolean) => {
        let { retData } = await roleService.change({ id, status: checked ? 1 : 0 })
        retData ?
            loadData() && globalPrompt("message", { text: "状态修改成功", type: "success" })
            : globalPrompt("message", { text: "状态修改失败", type: "error" });
        return retData;
    }
    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        drawerVisible,
        selectedRow,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        updatePgCfg,
        setDrawerVisible,
        setSelectedRow,
        onChange,
        loadAllRolesData
    }
});